import colors from "../../base/colors";

const { secondary } = colors;
const listItemIcon = {
  styleOverrides: {
    root: {
      marginTop: 0,
      marginBottom: 0,
      color: secondary.main,
    },
  },
};
export default listItemIcon;
